/**
 * Prefijos de celular de Venezuela (operadoras), en formato nacional: 4 dígitos con el 0 inicial. Es la única lista de
 * prefijos del front (FINA-3402): de acá salen la edición, el registro y la carga masiva de clientes, el envío rápido de
 * campañas, el débito inmediato del plan y el pago móvil de Créditos. El 0422 es de Digitel.
 *
 * El orden importa: Créditos toma `VE_MOBILE_PREFIXES[1]` (0414) como prefijo por defecto del pago móvil.
 *
 * Copias en los otros repos: misma lista, actualizar todas juntas.
 * - api/src/utils/phone.util.ts (misma forma; fuente de la decisión de SMS)
 * - frontEnd-admin/src/modules/app-common/utils/ve-mobile-prefixes.util.ts (misma forma)
 * - cron-jobs/src/utils/marketing.util.ts (misma forma)
 * - api-admin/src/endpoints/collections-campaigns/shared/msisdn.helper.ts (OTRA forma: 3 dígitos, sin el 0 ni el 58)
 */
export const VE_MOBILE_PREFIXES: ReadonlyArray<string> = ['0412', '0414', '0416', '0422', '0424', '0426'];

/** Celular nacional completo: un prefijo de la lista + 7 dígitos (04141234567). Sin flag `g`: se usa con `.test` repetido. */
export const VE_MOBILE_PHONE_REGEX = new RegExp(String.raw`^(${VE_MOBILE_PREFIXES.join('|')})\d{7}$`);

/** Los prefijos sin el 0 de larga distancia (412, 414…), como los compara el débito inmediato. */
export const VE_MOBILE_OPERATOR_CODES: ReadonlyArray<string> = VE_MOBILE_PREFIXES.map(prefix => prefix.slice(1));

/** «0412, 0414, 0416, 0422, 0424 o 0426», para mensajes y ayudas. */
export const VE_MOBILE_PREFIXES_TEXT = `${VE_MOBILE_PREFIXES.slice(0, -1).join(', ')} o ${VE_MOBILE_PREFIXES[VE_MOBILE_PREFIXES.length - 1]}`;
